
<div class="page-detail-wrap vetro-master-bg">
    <h5>{{"Master.frame" | translate}}</h5>
</div>
<div class="vetro-bg">
    <p-table #dt [value]="perfCriteriaList"  styleClass="p-datatable-gridlines"
        [globalFilterFields]="['name']" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50,100]">
         <ng-template pTemplate="caption">
            
            <div class="d-flex justify-content-between">
                <span class="p-input-icon-left p-ml-auto" width="300px">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)=" applyFilterGlobal($event,'contains')"
                        placeholder="Search..." />
                </span>
                <div class="d-flex table-action-wrap align-items-center">
                    <p-button type="button" icon="pi pi-plus-circle" pRipple class="btn-link mr-3"
                        pTooltip="Add" tooltipPosition="bottom" iconPos="left" (click)="addModal()" label="{{'commonbtn.add'|translate}}">
                    </p-button>
                    <button class="p-button p-button-raised" type="button" icon="pi pi-check" style="width: 100px; justify-content: center;"
                        (click)="export()">
                            {{ "commonbtn.export" | translate }}
                    </button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-model>
            <tr>
                <td>{{model.id}}</td>
                <td>{{model.name}}</td>
                <td> <a class="pi pi-pencil" style="color:#fddc88; text-align:center;" (click)="edit(model)"></a>
                    &nbsp;&nbsp;
                    <a class="pi pi-trash" style="color:red; text-align:center;" (click)="delete(model)"></a>
        </td>
            </tr>
        </ng-template>
    </p-table>
</div>



